/* Aeve – snel toevoegen (+) met slide-in paneel. Teksten komen uit window.AEVE_I18N (locale-keys aeve.qa.*, gezet in snippets/aeve-quick-drawer.liquid); Nederlands is de terugval. */
(function () {
  if (window.__aeveQA) return; window.__aeveQA = true;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var I = window.AEVE_I18N || {};
  var T = function (k, d, r) {
    var s = (I[k] == null || I[k] === '') ? d : I[k];
    if (r) for (var x in r) s = s.split('{' + x + '}').join(r[x]);
    return s;
  };
  var numLocale = ((document.documentElement.lang || 'nl') + '').toLowerCase().slice(0, 2);
  var fmt = function (c) { if (c == null) return T('price_tbd', 'Prijs volgt'); try { return new Intl.NumberFormat(numLocale, { style: 'currency', currency: currency }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + currency; } };
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var sized = function (u, w) { if (!u) return ''; if (u.indexOf('data:') === 0) return u; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var drawer, body, lastFocus, p, variant, qty = 1, sel = [], mode = 'buy', soonLabel = T('soon_default', 'Vanaf 1 december');
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';

  function optName(o) { return typeof o === 'string' ? o : o.name; }
  function optValues(o, i) {
    if (o && o.values) return o.values;
    var seen = []; p.variants.forEach(function (v) { var x = v.options[i]; if (seen.indexOf(x) < 0) seen.push(x); }); return seen;
  }
  function hasOptions() { return !(p.variants.length === 1 && /^(Title|Default Title)$/.test(optName(p.options[0] || '') || 'Title')); }
  function findVariant() { return p.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }); }

  function open(handle, trigger, m) {
    mode = m || 'buy';
    soonLabel = (trigger && trigger.getAttribute('data-soon-label')) || T('soon_default', 'Vanaf 1 december');
    lastFocus = trigger || document.activeElement;
    drawer = drawer || document.getElementById('AeveQuickAdd');
    if (!drawer) return;
    body = drawer.querySelector('[data-body]');
    body.innerHTML = '<div class="aeve-qa__loading" aria-label="' + esc(T('loading', 'Laden')) + '"></div>';
    drawer.querySelector('.aeve-qa__head h2').textContent = mode === 'notify' ? T('soon_title', 'Binnenkort verkrijgbaar') : T('choose', 'Kies je opties');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.documentElement.classList.add('aeve-qa-lock');
    setTimeout(function () { var c = drawer.querySelector('.aeve-qa__close'); c && c.focus(); }, 60);
    var mock = window.AEVE_QA_MOCK && window.AEVE_QA_MOCK[handle];
    (mock ? Promise.resolve(mock) : fetch(root() + 'products/' + handle + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }))
      .then(function (data) {
        p = data; qty = 1;
        var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        sel = first.options.slice();
        mode === 'notify' ? renderNotify() : render();
      })
      .catch(function () { body.innerHTML = '<p class="aeve-qa__error">' + T('load_error_html', 'Dit product kon niet geladen worden. <a href="{url}">Bekijk de productpagina</a>.', { url: root() + 'products/' + esc(handle) }) + '</p>'; });
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aeve-qa-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function render() {
    var imgs = (p.media_images || p.images || []).slice(0, 2);
    var opts = '';
    if (hasOptions()) {
      p.options.forEach(function (o, i) {
        opts += '<fieldset class="aeve-qa__opt"><legend>' + esc(optName(o)) + ' <strong data-optlabel="' + i + '">' + esc(sel[i]) + '</strong></legend><div class="aeve-qa__pills">' +
          optValues(o, i).map(function (v) { return '<button type="button" class="aeve-qa__pill" data-opt="' + i + '" data-val="' + esc(v) + '" aria-pressed="' + (sel[i] === v) + '">' + esc(v) + '</button>'; }).join('') +
          '</div></fieldset>';
      });
    }
    body.innerHTML =
      '<div class="aeve-qa__media aeve-qa__media--' + imgs.length + '">' + imgs.map(function (src, i) {
        return '<div class="aeve-qa__img' + (i ? ' aeve-qa__img--mood' : '') + '"><img src="' + esc(sized(src, 800)) + '" alt="' + (i ? '' : esc(p.title)) + '" loading="lazy"></div>';
      }).join('') + '</div>' +
      '<div class="aeve-qa__info"><a class="aeve-qa__title" href="' + esc(p.url || (root() + 'products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
      (p.subtitle ? '<p class="aeve-qa__sub">' + esc(p.subtitle) + '</p>' : '') +
      '<p class="aeve-qa__price"><span data-price></span><s data-compare></s></p></div>' + opts +
      '<div class="aeve-qa__buy"><div class="aeve-qa__qty" role="group" aria-label="' + esc(T('qty_label', 'Aantal')) + '"><button type="button" data-qty="-1" aria-label="' + esc(T('less', 'Minder')) + '">−</button><output data-qtyout>1</output><button type="button" data-qty="1" aria-label="' + esc(T('more', 'Meer')) + '">+</button></div>' +
      '<button type="button" class="aeve-qa__add" data-add><span data-addlabel>' + esc(T('add', 'Toevoegen aan winkelwagen')) + '</span></button></div>' +
      '<p class="aeve-qa__note">' + CHECK + esc(T('shipped_note', 'Vandaag verzonden · 30 dagen bedenktijd')) + '</p>';
    update();
  }


  function renderNotify() {
    var imgs = (p.media_images || p.images || []).slice(0, 2);
    body.innerHTML =
      '<div class="aeve-qa__media aeve-qa__media--' + imgs.length + '">' + imgs.map(function (src, i) {
        return '<div class="aeve-qa__img' + (i ? ' aeve-qa__img--mood' : '') + '"><img src="' + esc(sized(src, 800)) + '" alt="' + (i ? '' : esc(p.title)) + '" loading="lazy"></div>';
      }).join('') + '</div>' +
      '<div class="aeve-qa__info"><p class="aeve-wait__date"><span aria-hidden="true"></span>' + esc(soonLabel) + '</p><a class="aeve-qa__title" href="' + esc(p.url || (root() + 'products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
      (p.subtitle ? '<p class="aeve-qa__sub">' + esc(p.subtitle) + '</p>' : '') + (p.price != null ? '<p class="aeve-qa__price"><span>' + fmt(p.price) + '</span></p>' : '') + '</div>' +
      '<p class="aeve-qa__soon">' + T('soon_text', 'We introduceren {title} op 1 december. Laat je e-mailadres achter en je hoort het als eerste.', { title: esc(p.title) }) + '</p>' +
      '<form class="aeve-qa__notify" method="post" action="' + root() + 'contact#aanmelden" data-notify-form>' +
      '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="newsletter,wachtlijst-december,interesse-' + esc(p.handle) + '">' +
      '<label class="visually-hidden" for="AeveQaEmail">' + esc(T('email_label', 'E-mailadres')) + '</label><input id="AeveQaEmail" type="email" name="contact[email]" required autocomplete="email" placeholder="' + esc(T('email_placeholder', 'Je e-mailadres')) + '">' +
      '<button type="submit" class="aeve-qa__add">' + esc(T('notify_button', 'Houd me op de hoogte')) + '</button></form>' +
      '<p class="aeve-qa__note">' + CHECK + esc(T('notify_note', 'Alleen bericht over de introductie · afmelden kan altijd')) + '</p>';
    var f = body.querySelector('[data-notify-form]');
    if (window.AEVE_QA_MOCK && window.AEVE_QA_MOCK[p.handle]) f.addEventListener('submit', function (e) { e.preventDefault(); notified(f.querySelector('input[type=email]').value); });
  }
  function notified(mail) {
    drawer.querySelector('.aeve-qa__head h2').textContent = T('listed_title', 'Je staat op de lijst');
    var img = (p.media_images || p.images || [])[0];
    body.innerHTML = '<div class="aeve-qa__done"><div class="aeve-qa__done-img">' + (img ? '<img src="' + esc(sized(img, 300)) + '" alt="">' : '') + '<span class="aeve-qa__done-check">' + CHECK + '</span></div>' +
      '<div><strong>' + esc(p.title) + '</strong><span>' + esc(soonLabel) + '</span></div></div>' +
      '<p class="aeve-qa__done-text">' + T('listed_text', 'We mailen {email} zodra {title} te koop is.', { email: esc(mail), title: esc(p.title) }) + '</p>' +
      '<button type="button" class="aeve-qa__ghost" data-close>' + esc(T('keep_browsing', 'Verder kijken')) + '</button>';
  }

  function update() {
    variant = findVariant();
    var price = variant ? variant.price : (p.price == null ? null : p.price);
    body.querySelector('[data-price]').textContent = fmt(price);
    var cmp = variant && variant.compare_at_price > variant.price ? fmt(variant.compare_at_price) : '';
    body.querySelector('[data-compare]').textContent = cmp;
    body.querySelectorAll('.aeve-qa__pill').forEach(function (b) {
      var i = +b.dataset.opt; b.setAttribute('aria-pressed', String(sel[i] === b.dataset.val));
      var test = sel.slice(); test[i] = b.dataset.val;
      var v = p.variants.find(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); });
      b.classList.toggle('is-unavailable', !v || !v.available);
    });
    body.querySelectorAll('[data-optlabel]').forEach(function (s) { s.textContent = sel[+s.dataset.optlabel]; });
    body.querySelector('[data-qtyout]').textContent = qty;
    var add = body.querySelector('[data-add]');
    var ok = variant && variant.available;
    add.disabled = !ok;
    body.querySelector('[data-addlabel]').textContent = ok ? T('add', 'Toevoegen aan winkelwagen') : (variant ? T('sold_out', 'Uitverkocht') : T('unavailable', 'Niet beschikbaar'));
  }

  function bumpBubble(n) {
    var icon = document.querySelector('#cart-icon-bubble, .header__icon--cart'); if (!icon) return;
    var b = icon.querySelector('.cart-count-bubble');
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; b.innerHTML = '<span aria-hidden="true">0</span>'; icon.appendChild(b); }
    var s = b.querySelector('span'); s.textContent = (+s.textContent || 0) + n;
  }

  function added() {
    drawer.querySelector('.aeve-qa__head h2').textContent = T('added_title', 'Toegevoegd');
    var img = (p.media_images || p.images || [])[0];
    body.innerHTML = '<div class="aeve-qa__done"><div class="aeve-qa__done-img">' + (img ? '<img src="' + esc(sized(img, 300)) + '" alt="">' : '') + '<span class="aeve-qa__done-check">' + CHECK + '</span></div>' +
      '<div><strong>' + esc(p.title) + '</strong><span>' + (variant.price == null ? qty + ' ' + (qty > 1 ? T('piece_many', 'stuks') : T('piece_one', 'stuk')) : qty + ' × ' + fmt(variant.price)) + (hasOptions() ? ' · ' + esc(sel.join(' / ')) : '') + '</span></div></div>' +
      '<p class="aeve-qa__done-text">' + esc(T('added_text', 'Staat in je winkelwagen. Goede keuze!')) + '</p>' +
      '<a class="aeve-qa__add" href="' + root() + 'cart" data-view-cart>' + esc(T('view_cart', 'Bekijk winkelwagen')) + '</a>' +
      '<button type="button" class="aeve-qa__ghost" data-close>' + esc(T('keep_shopping', 'Verder winkelen')) + '</button>';
  }

  function add() {
    var btn = body.querySelector('[data-add]'); if (!variant || btn.disabled) return;
    btn.classList.add('is-loading'); btn.disabled = true;
    if (window.AEVE_QA_MOCK && window.AEVE_QA_MOCK[p.handle]) { setTimeout(function () { bumpBubble(qty); added(); }, 450); return; }
    fetch(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }], sections: 'cart-icon-bubble,cart-drawer' })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var dp = new DOMParser(), s = j.sections || {};
        if (s['cart-icon-bubble']) {
          var nb = dp.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          var bubble = document.getElementById('cart-icon-bubble'); if (nb && bubble) bubble.innerHTML = nb.innerHTML;
        } else bumpBubble(qty);
        if (s['cart-drawer']) {
          var nd = dp.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          var cd = document.getElementById('CartDrawer'); if (nd && cd) cd.innerHTML = nd.innerHTML;
          var el = document.querySelector('cart-drawer'); el && el.classList.remove('is-empty');
        }
        added();
      })
      .catch(function (e) {
        btn.classList.remove('is-loading'); btn.disabled = false;
        var msg = (e && (e.description || e.message)) || T('add_error', 'Toevoegen lukte niet, probeer het opnieuw.');
        var n = body.querySelector('.aeve-qa__error'); if (!n) { n = document.createElement('p'); n.className = 'aeve-qa__error'; btn.parentNode.after(n); }
        n.textContent = msg;
      });
  }

  /* '+' op de kaart: enkele beschikbare variant = direct in winkelwagen, anders het optiepaneel */
  var LBL = {
    nl: ['Toevoegen aan winkelwagen', 'Toegevoegd aan winkelwagen', 'Toevoegen mislukt, probeer het opnieuw'],
    de: ['In den Warenkorb', 'Zum Warenkorb hinzugefügt', 'Hinzufügen fehlgeschlagen'],
    fr: ['Ajouter au panier', 'Ajouté au panier', "Échec de l'ajout au panier"],
    en: ['Add to cart', 'Added to cart', 'Could not add to cart']
  };
  var L = LBL[((document.documentElement.lang || 'nl') + '').slice(0, 2).toLowerCase()] || LBL.nl;
  var prodCache = {}, liveEl, plusCss = document.createElement('style');
  plusCss.textContent = '.aeve-qa-plus.is-loading{cursor:progress}.aeve-qa-plus.is-loading svg{opacity:0}' +
    '.aeve-qa-plus.is-loading::after{content:"";position:absolute;top:50%;left:50%;width:1.4rem;height:1.4rem;margin:-0.7rem 0 0 -0.7rem;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:aeve-qa-spin .7s linear infinite}' +
    '.aeve-qa-plus.is-added{background:var(--aeve-viridian,#344945);color:#fff}.aeve-qa-plus.is-error{background:#8a3b2f;color:#fff}' +
    '.card__inner:has(.aeve-qa-plus){z-index:3;pointer-events:none}.aeve-qa-plus{z-index:5;pointer-events:auto;touch-action:manipulation}.aeve-qa-plus *{pointer-events:none}' +
    '@keyframes aeve-qa-spin{to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){.aeve-qa-plus.is-loading::after{animation-duration:2s}}';
  document.head.appendChild(plusCss);
  function say(t) {
    if (!liveEl) { liveEl = document.createElement('div'); liveEl.className = 'visually-hidden'; liveEl.setAttribute('role', 'status'); liveEl.setAttribute('aria-live', 'polite'); document.body.appendChild(liveEl); }
    liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = t; }, 30);
  }
  function labelPlus() {
    document.querySelectorAll('[data-aeve-quick-add]:not([data-aeve-l])').forEach(function (b) {
      var m = b.getAttribute('aria-label') || '', i = m.indexOf(': ');
      b.setAttribute('aria-label', L[0] + (i > -1 ? m.slice(i) : '')); b.setAttribute('data-aeve-l', '1');
    });
  }
  labelPlus();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', labelPlus);
  if ('MutationObserver' in window) { var lt; new MutationObserver(function () { clearTimeout(lt); lt = setTimeout(labelPlus, 80); }).observe(document.documentElement, { childList: true, subtree: true }); }
  function idle(btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
  function flash(btn, cls, icon, text) {
    var orig = btn.innerHTML;
    idle(btn); btn.classList.add(cls); if (icon) btn.innerHTML = icon; say(text);
    setTimeout(function () { btn.classList.remove(cls); btn.innerHTML = orig; }, 2200);
  }
  function pick(html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); }
  function directAdd(btn, id) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-icon-bubble,cart-drawer' })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var s = j.sections || {}, bubble = document.getElementById('cart-icon-bubble'), cd = document.querySelector('cart-drawer');
        if (s['cart-icon-bubble'] && bubble) { var nb = pick(s['cart-icon-bubble'], '.shopify-section'); if (nb) bubble.innerHTML = nb.innerHTML; }
        if (s['cart-drawer'] && cd) {
          var nd = pick(s['cart-drawer'], '#CartDrawer'), cur = document.getElementById('CartDrawer');
          if (nd && cur) cur.innerHTML = nd.innerHTML;
          cd.classList.remove('is-empty');
          if (typeof cd.open === 'function') { try { cd.open(btn); } catch (err) {} }
        }
        flash(btn, 'is-added', CHECK, L[1]);
      })
      .catch(function () { flash(btn, 'is-error', null, L[2]); });
  }
  function quick(btn) {
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    var handle = btn.getAttribute('data-aeve-quick-add');
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    (prodCache[handle] = prodCache[handle] || fetch(root() + 'products/' + handle + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }))
      .then(function (pr) {
        var v = pr.variants.length === 1 ? pr.variants[0] : null;
        if (!v || !v.available) { idle(btn); open(handle, btn); return; }
        return directAdd(btn, v.id);
      })
      .catch(function () { delete prodCache[handle]; idle(btn); open(handle, btn); });
  }

  /* Welke +/bel-knop zit onder de aanwijzer? Ook als een overlay (stretched link) het event onderschept: geometrie als vangnet. */
  function plusAt(e, attr) {
    var el = e.target && e.target.closest ? e.target.closest('[' + attr + ']') : null;
    if (el) return el;
    if (!e.clientX && !e.clientY) return null;
    if (e.target && e.target.closest && e.target.closest('.aeve-qa, cart-drawer, header, [role="dialog"], dialog')) return null;
    var list = document.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width && e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) return list[i];
    }
    return null;
  }
  ['pointerdown', 'mousedown', 'mouseup', 'pointerup', 'touchstart', 'touchend'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var pt = e.changedTouches && e.changedTouches[0] ? { target: e.target, clientX: e.changedTouches[0].clientX, clientY: e.changedTouches[0].clientY } : e;
      if (plusAt(pt, 'data-aeve-quick-add') || plusAt(pt, 'data-aeve-notify')) e.stopPropagation();
    }, true);
  });

  document.addEventListener('click', function (e) {
    var t = plusAt(e, 'data-aeve-quick-add');
    if (t) { e.preventDefault(); e.stopPropagation(); quick(t); return; }
    var nt = plusAt(e, 'data-aeve-notify');
    if (nt) { e.preventDefault(); e.stopPropagation(); open(nt.getAttribute('data-aeve-notify'), nt, 'notify'); return; }
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); return; }
    var pill = e.target.closest('.aeve-qa__pill'); if (pill) { sel[+pill.dataset.opt] = pill.dataset.val; update(); return; }
    var q = e.target.closest('[data-qty]'); if (q) { qty = Math.max(1, Math.min(99, qty + (+q.dataset.qty))); update(); return; }
    if (e.target.closest('[data-add]')) { add(); return; }
    var vc = e.target.closest('[data-view-cart]'); var cd = document.querySelector('cart-drawer');
    if (vc && cd && typeof cd.open === 'function') { e.preventDefault(); close(); cd.open(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close(); });
  window.aeveQuickAdd = { open: open, close: close };
})();

/* Aeve – direct in winkelwagen (knoppen met data-aeve-add-variant) */
(function () {
  if (window.__aeveDirectAdd) return; window.__aeveDirectAdd = true;
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var addedShort = function () { var I = window.AEVE_I18N || {}; return I.added_short || '✓ Toegevoegd'; };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-aeve-add-variant]'); if (!b) return;
    e.preventDefault(); if (b.classList.contains('is-loading')) return;
    var label = b.innerHTML; b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true');
    fetch(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-aeve-add-variant'), quantity: 1 }], sections: 'cart-icon-bubble,cart-drawer' })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var dp = new DOMParser(), s = j.sections || {};
        if (s['cart-icon-bubble']) { var nb = dp.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); var bubble = document.getElementById('cart-icon-bubble'); if (nb && bubble) bubble.innerHTML = nb.innerHTML; }
        var cd = document.querySelector('cart-drawer');
        if (s['cart-drawer'] && cd) {
          var nd = dp.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          var cur = document.getElementById('CartDrawer'); if (nd && cur) cur.innerHTML = nd.innerHTML;
          cd.classList.remove('is-empty');
          if (typeof cd.open === 'function') { cd.open(b); } else { window.location.href = root() + 'cart'; }
        } else { window.location.href = root() + 'cart'; }
        b.classList.remove('is-loading'); b.removeAttribute('aria-busy');
        b.innerHTML = addedShort(); setTimeout(function () { b.innerHTML = label; }, 2200);
      })
      .catch(function () { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); window.location.href = b.getAttribute('href') || root() + 'cart'; });
  });
})();
